export default function onFirstView(element: Element, callback: () => void) {
  const observer = new IntersectionObserver(entries => {
    if (!entries.some(entry => entry.isIntersecting)) return

    observer.disconnect()
    callback()
  })
  observer.observe(element)
}
